import { render, staticRenderFns } from "./EditPenaltyModal.vue?vue&type=template&id=4a019540&"
import script from "./EditPenaltyModal.vue?vue&type=script&lang=js&"
export * from "./EditPenaltyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports